function ServicePage() {
  return <div>Service</div>;
}

export default ServicePage;
